import React from "react";
import tw from "tailwind-styled-components";
import { FaChevronRight, FaFileAlt, FaRegFileAlt } from "react-icons/fa";
import { FiLogOut, FiUsers } from "react-icons/fi";
import { LuClipboardList } from "react-icons/lu";
import { AiOutlineNotification } from "react-icons/ai";
import { TiArrowMoveOutline } from "react-icons/ti";
import { BsNewspaper } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { TbCurrentLocation } from "react-icons/tb";

const settingsOptions = [
  // {
  //   title: "Property Settings",
  //   description: "View and update property details",
  //   icon: <FiHome size={24} />,
  //   modalType: "PropertySettings",
  // },
  // {
  //   title: "Company Details",
  //   description: "Set company informations",
  //   icon: <BsNewspaper size={24} />,
  //   modalType: "ManagementDetails",
  // },
  {
    title: "Rent & Agreement Settings",
    description: "Set rent and agrrement settings",
    icon: <LuClipboardList size={24} />,
    modalType: "RentingStayRules",
  },
  // {
  //   title: "Dues & Payment Settings",
  //   description: "Configure payment settings",
  //   icon: <IoDocumentTextOutline size={24} />,
  //   modalType: "DuesPaymentSettings",
  // },
  // {
  //   title: "Notification Settings",
  //   description: "Tenant notification settings",
  //   icon: <IoMdNotificationsOutline size={24} />,
  //   modalType: "TenantKYC",
  // },
  {
    title: "Tenant Onboarding Settings",
    description: "Configure onboarding settings",
    icon: <FiUsers size={24} />,
    modalType: "OnboardingSettings",
  },
  // {
  //   title: "Eviction Settings",
  //   description: "Set eviction rules",
  //   icon: <TiArrowMoveOutline size={24} />,
  //   modalType: "EvictionSettings",
  // },
  {
    title: "Notification & Messages",
    description: "Manage communication settings",
    icon: <AiOutlineNotification size={24} />,
    modalType: "NotificationSettings",
  },
  {
    title: "Reports",
    description: "Easily Generate and Download Detailed Reports.",
    icon: <FaRegFileAlt size={24} />,
    modalType: "Report",
  },
  {
    title: "Location",
    description: "View, add and edit locations",
    icon: <TbCurrentLocation size={24} />,
    modalType: "Location",
  },
  // {
  //   title: "Logout",
  //   description: "Sign out of your account securely and manage session settings.",
  //   icon: <FiLogOut size={24} />,
  //   modalType: "Logout",
  // },

];

const Table = ({ setOpenModal, settingsData, setIsLogout, }) => {
  const navigate = useNavigate();
  const handleOptionClick = (modalType) => {
    if (modalType === "Logout") {
      setIsLogout(true);
      return;
    }
    if (modalType === "Report") {
      navigate("/reports");
      return;
    }
    if (modalType === "Location") {
      navigate("/location");
      return;
    }
    if (modalType) {
      setOpenModal(modalType);
    }
  };

  return (
    <Wrapper>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
        {settingsOptions.map((option, index) => (
          <OptionGroup
            key={index}
            onClick={() => handleOptionClick(option.modalType)}
            className={`cursor-pointer ${option.modalType ? "hover:bg-gray-100 transition" : ""
              }`}
          >
            <Header>
              <div className="text-gray-600">{option.icon}</div>

              <OptionContent>
                <OptionTitle>{option.title}</OptionTitle>
                <OptionDescription>{option.description}</OptionDescription>
              </OptionContent>

              <ChevronWrapper>
                <FaChevronRight />
              </ChevronWrapper>
            </Header>
          </OptionGroup>
        ))}
      </div>
    </Wrapper>
  );
};

const Wrapper = tw.div`px-2 md:px-6 space-y-6 my-6 `;
const OptionGroup = tw.div`py-4 px-2.5 md:p-5  bg-white rounded-lg border shadow-sm`;
const Header = tw.div`flex items-center w-full px-0`;
const OptionContent = tw.div`flex flex-col ml-2 md:ml-4 `;
const ChevronWrapper = tw.div`text-gray-400 text-sm ml-auto`;
const OptionTitle = tw.h3`text-gray-800 md:text-lg text-md  font-medium`;
const OptionDescription = tw.p`text-gray-500 text-sm`;

export default Table;
